// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SellerReviews__selfBlocked":"gu_a bia_ea bia_va bia_ts bia_vm bia_vh"};